import { MovementCallins } from "../../../powerbroker/src/MovementCallins";
import { MovementCarrierPay } from "../../../powerbroker/src/MovementCarrierPay";
import { TopMatchList } from "../../../powerbroker/src/TopMatchList";
import { TableTriumphPayAuditDocument } from "../../../settlement/src/TableTriumphPayAuditDocument";
import { TriumphPayTxAudit } from "../../../settlement/src/TriumphPayTxAudit";
import { AssignedMovementOverview } from "../AssignedMovementOverview";
import { AvailableMovementOverview } from "../AvailableMovementOverview";
import { MovementMap } from "../MovementMap";
import { StopList } from "../StopList";
import { StopProgress } from "../StopProgress";
import { DispatchEquipAlerts } from "../asset/DispatchEquipAlerts";
import { MovementRouting } from "../asset/MovementRouting";
import { TrackingHistory } from "../asset/TrackingHistory";
import { Button, CityState, DataHeader, DataSource, HorizontalSpacer, Image, Label, Layout, Panel, Splitter, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMovement extends Layout {
    buttonAssignCarrier: Button;
    buttonClassicMode: Button;
    buttonDispatch: Button;
    buttonManageAssign: Button;
    buttonOrderDetails: Button;
    buttonUsers: Button;
    dataheaderMovement: DataHeader;
    horizontalspacer2: HorizontalSpacer;
    imageLinked: Image;
    imageManifest: Image;
    imageYSplit: Image;
    labelAddress1: Label;
    labelDash: Label;
    labelDimensions: Label;
    labelHoldBadge: Label;
    labelInvoiceHistory: Label;
    labelManifestTemp: Label;
    labelMoveId: Label;
    labelMovementStatus: Label;
    labelMovementView: Label;
    labelOrderView: Label;
    labelPendingAssignment: Label;
    labelTemperatureRange: Label;
    labelTo: Label;
    layoutAssignedOverview: AssignedMovementOverview;
    layoutAvailableOverview: AvailableMovementOverview;
    layoutCarrierRates: MovementCarrierPay;
    layoutEquipAlerts: DispatchEquipAlerts;
    layoutMovementCallins: MovementCallins;
    layoutMovementMap: MovementMap;
    layoutMovementRouting: MovementRouting;
    layoutStopList: StopList;
    layoutStopProgress: StopProgress;
    layoutTableTriumphPayAuditDocument: TableTriumphPayAuditDocument;
    layoutTopMatchList: TopMatchList;
    layoutTrackingHistory: TrackingHistory;
    layoutTriumphPayTxAudit: TriumphPayTxAudit;
    panel5: Panel;
    panelCustomerInfo: Panel;
    panelDimensions: Panel;
    panelDimensionsAndSurcharge: Panel;
    panelInvoiceHistoryTab: Panel;
    panelManifestCustInfo: Panel;
    panelManifestTemps: Panel;
    panelMovementStatus: Panel;
    panelMovementTab: Panel;
    panelMovementTabController: Panel;
    panelOrderTab: Panel;
    panelOrderTabs: Panel;
    panelOverview: Panel;
    panelRates: Panel;
    panelTemperatureRange: Panel;
    panelTrackingLayouts: Panel;
    sourceBrokerageTracking: DataSource;
    sourceCustomer: DataSource;
    sourceEquipmentGroup: DataSource;
    sourceHubtranTrx: DataSource;
    sourceMovement: DataSource;
    sourceResponsibleHist: DataSource;
    sourceStop: DataSource;
    sourceUnitMessage: DataSource;
    splitterTracking: Splitter;
    tabDocuments: Tab;
    tabEquipmentAlerts: Tab;
    tabEquipmentAssigned: Tab;
    tabExceptions: Tab;
    tabOrderDetails: Tab;
    tabOverview: Tab;
    tabRates: Tab;
    tabTopMatch: Tab;
    tabTracking: Tab;
    tabTriumphPay: Tab;
    tabsetMain: Tabset;
    tabsetTPAudit: Tabset;
    textboxBrokerageStatus: Textbox;
    textboxCityId: CityState;
    textboxCustomerId: Textbox;
    textboxDimHeight: Textbox;
    textboxDimLength: Textbox;
    textboxDimSurcharge: Textbox;
    textboxDimWidth: Textbox;
    textboxManifestCustomers: Textbox;
    textboxManifestId: Textbox;
    textboxManifestMaxTemp: Textbox;
    textboxManifestMinTemp: Textbox;
    textboxManifestOrderValue: Textbox;
    textboxManifestTeamsRequired: Textbox;
    textboxMoveId: Textbox;
    textboxOrderNumber: Textbox;
    textboxOrderValue: Textbox;
    textboxOrdersSegAllocCode: Textbox;
    textboxRoundTrip: Textbox;
    textboxSegAllocCode: Textbox;
    textboxTeamsRequired: Textbox;
    textboxTemperatureMax: Textbox;
    textboxTemperatureMin: Textbox;
}
